// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"oy_a bha_i bha_j bha_q bha_un bha_wf bha_en"};